import { Buffer } from 'buffer';

const convertPDFToImage = async (pdfString: string) => {
  const { pdfjs } = await import('react-pdf');

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const pdf = await pdfjs.getDocument(pdfString).promise;
  const firstPage = await pdf.getPage(1);

  const scale = 1.5;
  const viewport = firstPage.getViewport({ scale });
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  const context = canvas.getContext('2d') as CanvasRenderingContext2D;
  canvas.height = viewport.height;
  canvas.width = viewport.width;

  await firstPage.render({ canvasContext: context, viewport }).promise;
  const base64imgFromPdf = canvas.toDataURL('image/jpeg');
  return base64imgFromPdf;
};

const getBase64FromFile = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      let result = reader.result as string;

      if (result.startsWith('data:application/pdf')) {
        result = await convertPDFToImage(result);
      }
      return resolve(result.split(',').pop() as string);
    };
    reader.onerror = (error) => reject(error);
  });

const getFileFromUrl = async (url: string) => {
  const response = await fetch(url);
  const data = await response.blob();
  return new File([data], url);
};

const getBase64FromURL = async (url: string) => getBase64FromFile(await getFileFromUrl(url));

const createFileFromBase64 = (base64File: string, name: string) => {
  const buff = Buffer.from(base64File, 'base64');
  return new File([buff], `${name.substring(0, name.lastIndexOf('.'))}.jpeg`, {
    type: 'image/jpeg',
  });
};

const base64ToInt8Array = (base64: string) => {
  const raw = window.atob(base64);
  const uint8Array = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    uint8Array[i] = raw.charCodeAt(i);
  }
  return uint8Array;
};

const base64ToFile = (base64: string, name: string, extension = 'pdf') => {
  return new File([base64ToInt8Array(base64)], `${name}.${extension}`);
};

export {
  getBase64FromFile,
  createFileFromBase64,
  getFileFromUrl,
  getBase64FromURL,
  base64ToInt8Array,
  base64ToFile,
};
